import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _vm.lst_report.length == 0
        ? _c("StateComponent", {
            attrs: {
              state: "empty_state",
              title: _vm.$t("my_pendings.no_requests"),
              subtitle: _vm.$t("my_pendings.no_requests_subtitle"),
            },
          })
        : _c(VDataTable, {
            key: _vm.keyTable,
            staticClass: "table-inca",
            style: { "font-size": "11px" },
            attrs: {
              responsive: "",
              hover: "",
              items: _vm.lst_report,
              headers: _vm.fieldsDs,
              search: _vm.filter,
              "sticky-header": true,
              "hide-default-footer": "",
              "single-select": false,
              "item-key": "document_id",
            },
            scopedSlots: _vm._u([
              {
                key: "header.data-table-select",
                fn: function (ref) {
                  return undefined
                },
              },
              {
                key: "item.data-table-select",
                fn: function (ref) {
                  var item = ref.item
                  var isSelected = ref.isSelected
                  return [
                    _c(VCheckbox, {
                      on: {
                        change: function ($event) {
                          return _vm.onItemSelected($event, item, _vm.onOwnerDs)
                        },
                      },
                      model: {
                        value: isSelected,
                        callback: function ($$v) {
                          isSelected = $$v
                        },
                        expression: "isSelected",
                      },
                    }),
                  ]
                },
              },
              {
                key: "item.objectReference.object_name",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c("div", { staticClass: "text-left" }, [
                      _c("b", { staticClass: "table-name" }, [
                        _vm._v(_vm._s(item.objectReference.object_name)),
                      ]),
                      _c("br"),
                      _c("a", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.composeName(item.objectReference)
                          ),
                        },
                      }),
                    ]),
                  ]
                },
              },
              {
                key: "item.lastmodifiedtime",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c("a", [
                      _vm._v(
                        _vm._s(_vm._f("formatDate")(item.lastModifiedTime))
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "item.actions",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c(
                      VTooltip,
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    VBtn,
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "btn-icon-inca",
                                          attrs: { icon: "", small: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onOwnerDs(item)
                                            },
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c(VIcon, { attrs: { small: "" } }, [
                                        _vm._v("icon-view"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("my_pendings.view_request"))),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.rows_selected,
              callback: function ($$v) {
                _vm.rows_selected = $$v
              },
              expression: "rows_selected",
            },
          }),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_REPORT_CHANGE_METADATA,
          attrs: {
            title: _vm.$t("my_pendings.view_change_metadata"),
            width: 1200,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-change-meta-data-report", {
                key: _vm.key_modal_meta,
                ref: _vm.MODAL_REPORT_CHANGE_METADATA + "_body",
                attrs: { item: _vm.item },
                on: { onCloseModal: _vm.onCloseModalDs },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { outlined: "", color: "secondary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[
                        _vm.MODAL_REPORT_CHANGE_METADATA + "_body"
                      ].onReject()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons md-16" }, [
                    _vm._v("block"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.reject"))),
                ]
              ),
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[
                        _vm.MODAL_REPORT_CHANGE_METADATA + "_body"
                      ].onAccept()
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("mdi-check-circle-outline"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.accept"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_REPORT_ACCESS_REQUEST,
          attrs: { title: _vm.$t("my_pendings.view_request"), width: 1200 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-access-request-report", {
                key: _vm.key_modal_access,
                ref: _vm.MODAL_REPORT_ACCESS_REQUEST + "_body",
                attrs: {
                  item: _vm.item.objectReference,
                  accessRequest: _vm.item,
                },
                on: { onCloseModal: _vm.onCloseModalDs },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-2",
                  attrs: { outlined: "", color: "secondary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[
                        _vm.MODAL_REPORT_ACCESS_REQUEST + "_body"
                      ].onReject()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons md-16" }, [
                    _vm._v("not_interested"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.reject"))),
                ]
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-2",
                  attrs: { primary: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[
                        _vm.MODAL_REPORT_ACCESS_REQUEST + "_body"
                      ].onAccept()
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("mdi-check-circle-outline"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.accept"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.DIALOG_ADD_ACCESS_REQUEST,
          attrs: { title: _vm.$t("my_pendings.view_request"), width: 1200 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-access-request-report", {
                key: _vm.key_modal_access,
                ref: _vm.DIALOG_ADD_ACCESS_REQUEST + "_body",
                attrs: {
                  item: _vm.item.objectReference,
                  accessRequest: _vm.item,
                },
                on: { submit: _vm.onAddItem, onCloseModal: _vm.onCloseModalDs },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-2",
                  attrs: { outlined: "", color: "secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs[_vm.DIALOG_ADD_ACCESS_REQUEST].onClose()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons md-16" }, [
                    _vm._v("not_interested"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.cancel"))),
                ]
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-2",
                  attrs: { primary: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[
                        _vm.DIALOG_ADD_ACCESS_REQUEST + "_body"
                      ].onAcceptAdd()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons md-16" }, [
                    _vm._v("send"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.accept"))),
                ]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }